(function ($) {
  'use strict';
  var KnowledgeTest = function (obj) {
    var _this = this;

    this.obj = obj;

    this.position = 1;

    this.length = obj.find('.question:not(.question-results)').length;

    this.storageKey = 'skt-result-' + obj.attr('data-id');

    this.chart = {
      correct: null,
      wrong: null,
    };

    this.answers = {
      correct: 0,
      wrong: 0,
    };

    this.watchAnswers();
    this.createCharts();

    //next button
    this.obj.find('.btn-next').click(function (e) {
      e.preventDefault();

      if ($(this).hasClass('disabled')) {
        return false;
      }

      _this.next();
    });

    //show results button
    this.obj.find('.btn-show-results').click(function (e) {
      e.preventDefault();

      if ($(this).hasClass('disabled')) {
        return false;
      }

      _this.next();
      _this.saveResult();
      _this.calculateResult();
      _this.obj.addClass('finished');
    });

    //show results button
    this.obj.find('.btn-show').click(function (e) {
      e.preventDefault();

      _this.next(1);
    });

    this.restoreSavedResult();
  };

  KnowledgeTest.prototype.decode = function (x) {
    var str = '';
    for (var i = 0; i < x.length; i += 2)
      str += String.fromCharCode(parseInt(x.substr(i, 2), 16));
    return str;
  };

  KnowledgeTest.prototype.calculateResult = function () {
    var correctAnswers = 0;
    jQuery.each(
      this.obj.find('.answers input[type=radio]:checked'),
      function (index, el) {
        if (
          jQuery(el)
            .attr('class')
            .indexOf(this.decode(4 * 20 - 17 + '')) > -1
        ) {
          correctAnswers += 1;
        }
      }.bind(this)
    );

    var allAnswers = this.obj.find('.answers').length;
    var correctPercent = Math.round((correctAnswers / allAnswers) * 100);
    var incorrectPercent = 100 - correctPercent;

    this.answers = {
      correct: correctAnswers,
      wrong: allAnswers - correctAnswers,
    };

    this.obj.find('.correct .percent').html(correctPercent + '%');
    this.obj.find('.wrong .percent').html(incorrectPercent + '%');
    this.obj
      .find('.correct .sum')
      .html(this.answers.correct + '/' + this.length);
    this.obj.find('.wrong .sum').html(this.answers.wrong + '/' + this.length);

    //prepare for readonly showdown of results
    this.obj.find('.answers input[type=radio]').prop('disabled', true);
    jQuery.each(
      this.obj.find('.answers input[type=radio]'),
      function (index, el) {
        if (
          jQuery(el)
            .attr('class')
            .indexOf(this.decode(4 * 20 - 17 + '')) > -1
        ) {
          jQuery(el).parent().addClass('good');
        }

        if (
          jQuery(el).is(':checked') &&
          !jQuery(el).parent().hasClass('good')
        ) {
          jQuery(el).parent().addClass('bad');
        }
      }.bind(this)
    );

    setTimeout(
      function () {
        this.chart.correct.progress(correctPercent);
        this.chart.wrong.progress(100 - incorrectPercent); //reverted chart
      }.bind(this),
      300
    );
  };

  KnowledgeTest.prototype.next = function (override) {
    this.position++;

    this.obj
      .find('img')
      .filter(function () {
        return !$(this).attr('src');
      })
      .each(function () {
        $(document).trigger('LazyLoad:reveal', [this]);
      });

    if (override) {
      this.position = override;
    }

    var length = this.length + 1;
    var piece = length > 0 ? 100 / length : 0;
    var transform = 'translateX(-' + (this.position - 1) * piece + '%)';
    this.obj.find('.questions').css({
      transform: transform,
    });
  };

  KnowledgeTest.prototype.watchAnswers = function () {
    //set default
    this.obj.find('.question').each(function () {
      var $el = jQuery(this);
      if ($el.find('.answers input:checked').length > 0) {
        $el.find('.btn-next, .btn-show-results').removeClass('disabled');
      } else {
        $el.find('.btn-next, .btn-show-results').addClass('disabled');
      }
    });

    //hook on change
    this.obj.find('.answers input').change(function () {
      var question = jQuery(this).parents('.question:first');
      if (question.find('.answers input:checked').length > 0) {
        question.find('.btn-next, .btn-show-results').removeClass('disabled');
      } else {
        question.find('.btn-next, .btn-show-results').addClass('disabled');
      }
    });
  };

  KnowledgeTest.prototype.saveResult = function () {
    var data = [];
    this.obj.find('.answers input:checked').each(function () {
      data.push(jQuery(this).attr('id'));
    });
    window.ysStorage.Set(this.storageKey, data);
  };

  KnowledgeTest.prototype.restoreSavedResult = function () {
    var savedResult = window.ysStorage.Get(this.storageKey);
    if (typeof savedResult !== 'undefined') {
      //check the radios
      for (var i = 0; i < savedResult.length; i++) {
        this.obj.find('#' + savedResult[i]).click();
      }
      this.obj.find('.questions').css({ 'transition-duration': '0s' });
      this.position = this.length;
      this.next();
      this.calculateResult();
    }
  };

  KnowledgeTest.prototype.createCharts = function () {
    if (this.chart.correct && this.chart.wrong) {
      return;
    }
    this.chart.correct = new WLCIcon('progress');
    this.chart.wrong = new WLCIcon('progress');

    this.obj.find('.correct .chart').prepend(this.chart.correct.get());
    this.obj.find('.wrong .chart').prepend(this.chart.wrong.get());
  };

  $('.knowledge-test').each(function () {
    new KnowledgeTest(jQuery(this));
  });
}).bind(window)(jQuery);
